<template>
  <TransitionRoot appear :show="showModal" as="template">
    <Dialog as="div" @close="closeModal(false)">
      <div class="fixed inset-0 z-10 overflow-y-auto">
        <div class="min-h-screen px-4 text-center flex">
          <DialogOverlay class="fixed inset-0 bg-black opacity-50" />

          <TransitionChild
            as="template"
            enter="duration-300 ease-out"
            enter-from="opacity-0 scale-95"
            enter-to="opacity-100 scale-100"
            leave="duration-200 ease-in"
            leave-from="opacity-100 scale-100"
            leave-to="opacity-0 scale-95"
          >
            <div
              class="inline-block w-full max-w-screen-sm py-6 md:p-6 mx-auto overflow-hidden text-left align-middle transition-all transform bg-white shadow-xl rounded my-auto"
              style="height: 90vh"
            >
              <template v-if="isScriptLoading">
                <Loading />
              </template>
              <div id="connect-container" class="w-full h-full" />
            </div>
          </TransitionChild>
        </div>
      </div>
    </Dialog>
  </TransitionRoot>
</template>
<script>
// import { mapGetters } from "vuex"
import * as Sentry from "@sentry/vue"

import { TransitionRoot, TransitionChild, Dialog, DialogOverlay } from "@headlessui/vue"

// import { XIcon } from "@heroicons/vue/outline"

export default {
  props: {
    showModal: {
      type: Boolean,
      default: false
    },
    connectUrl: {
      type: String,
      required: true
    }
  },
  components: {
    TransitionRoot,
    TransitionChild,
    Dialog,
    DialogOverlay
  },
  mounted() {
    if (!window.finicityConnect) {
      this.loadFinicityConnectScript()
    } else {
      this.loadFinicityIframe()
    }
  },
  data() {
    return {
      isScriptLoading: false,
      events: []
    }
  },
  methods: {
    closeModal(next) {
      window.finicityConnect.destroy()
      this.$emit("close", next)
    },
    loadFinicityIframe() {
      window.finicityConnect.launch(this.connectUrl, {
        selector: "#connect-container",
        success: (event) => {
          this.events.push(event)
          this.closeModal(true)
        },
        cancel: (event) => {
          this.events.push(event)
          this.closeModal(false)

          // Destroy Finicity iframe on cancel
          window.finicityConnect.destroy()
        },
        error: (error) => {
          this.events.push(error)
          Sentry.captureException(new Error("Finicity Connect error"), {
            extra: {
              events: this.events
            }
          })
        },
        loaded: () => {},
        route: (event) => {
          this.events.push(event)
        },
        user: (event) => {
          this.events.push(event)
        }
      })
    },
    loadFinicityConnectScript() {
      const that = this
      let script = document.createElement("script")
      this.isScriptLoading = true
      script.onload = () => {
        that.isScriptLoading = false
        that.loadFinicityIframe()
      }
      script.async = true
      script.src = "https://connect2.finicity.com/assets/sdk/finicity-connect.min.js"
      document.head.appendChild(script)
    }
  }
}
</script>
<style lang="scss">
#connect-container {
  iframe {
    width: 100%;
    height: 100%;
  }
}
</style>
